import type { PostApplyAdPendingState } from "./postApplyAdPending.types";

export type { PostApplyAdPendingState };

let pending: PostApplyAdPendingState | null = null;

/**
 * Records that a 3P apply has just been initiated on this tab. Read by
 * PostApplyAd's tab-return listener to decide whether the visibilitychange
 * event represents a real 3P-apply return vs. an arbitrary tab switch.
 */
export function markPostApplyAdPending(args: PostApplyAdPendingState): void {
  pending = args;
}

/**
 * Atomically read and clear the pending state. Returns null if no 3P apply
 * is pending. Called from PostApplyAd's tab-return listener.
 */
export function tryConsumePostApplyAdPending(): PostApplyAdPendingState | null {
  if (pending == null) return null;
  const captured = pending;
  pending = null;
  return captured;
}

/**
 * Test-only: reset module-level state between tests.
 */
export function __resetPostApplyAdPendingForTest(): void {
  pending = null;
}
